import Index from '@/pages/announce/Index'
import List from '@/pages/announce/List'
import Create from '@/pages/announce/Create'
import Modify from '@/pages/announce/Modify'

var serviceName = process.env.VUE_APP_SERVICE_NAME || 'Nichibyo'

export default {
  path: 'announce',
  component: Index,
  children: [
    {
      path: 'index',
      component: List
    },
    {
      path: 'create',
      component: Create,
      props: () => ({serviceName: serviceName})
    },
    {
    path: 'modify/:id',
    component: Modify,
    props: () => ({serviceName: serviceName})
    }
  ]
}